import { AiOutlineCloseCircle } from "react-icons/ai";
import { useSeller } from "../../../context/seller";
import Modal from "../../common/Modal";
import GeneralInput from "../../common/GeneralInput";
import dollar from '../../../assets/common/dollar.svg'
import { ChangeEvent, FormEvent, useEffect, useMemo, useState } from "react";
import * as CommonTypes from '../../../types/common.types'
import insert from "../../../utils/insert";
import { FaTrash } from "react-icons/fa6";
import Dropdown from "../../common/Dropdown";
import styled from "styled-components";
import SellerService from "../../../services/seller.service";
import { useGlobal } from "../../../context/global";
import ToursService from "../../../services/tours.service";
import Select from "../../common/Select";
import repartir from "../../../utils/repartir";

export default function TicketPaymentGroup() {
    const { setMessage, setIsLoading } = useGlobal()
    const { newGroup, setNewGroupReservations, setSummary, setIsConfirmBoucherModalOpen, 
        setIsTicketPaymentGroupModalOpen, newGroupReservationData, setNewGroupReservationData, user } = useSeller()
    const [tour, setTour] = useState<CommonTypes.TourInfo>()

    useEffect(() => {
        async function fetchTours() {
            try {
                const response = await ToursService.getDetailTourInfo(newGroupReservationData?.tour_id || '', user?.user.agency_id || '')
                setTour(response.data)
            } catch (error) {
                console.error('Error fetching tours:', error)
            }
        }
        fetchTours()
    }, [newGroupReservationData?.tour_id, user?.user.agency_id])

    const price_options = useMemo(() => {
        if (!tour) return []
        const options = []
        options.push({value: tour.current_price, name: `Current Price: $${tour.current_price}`})
        if (tour.discount_price) options.push({value: tour.discount_price, name: `Discount Price: $${tour.discount_price}`})
        if (tour.depart_price) options.push({value: tour.depart_price, name: `Depart Price: $${tour.depart_price}`})
        return options
    }, [tour])

    // Tour privado: se cobra por vehículo. Precio y pagos se cargan como total del grupo y se reparten.
    const privado = tour?.unidad_precio === 'por_vehiculo'
    const parte = privado && newGroupReservationData?.price ? repartir(newGroupReservationData.price, newGroup.length)[0] : 0
    const sobreCupo = privado && !!tour?.capacidad_ofrecida && newGroup.length > tour.capacidad_ofrecida

    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        const name = e.target.name
        setNewGroupReservationData({...newGroupReservationData, [name]: value})
    }

    function onSelectPayment(newMethod: string) {
        if (!newGroupReservationData?.payment_methods) {
            setNewGroupReservationData({...newGroupReservationData, payment_methods: [{name: newMethod}]})
            return
        }
        const new_data = newGroupReservationData.payment_methods ? [...newGroupReservationData.payment_methods, {name: newMethod}] : [{name: newMethod}]
        setNewGroupReservationData({...newGroupReservationData, payment_methods: new_data})
    }

    function onChangePayment(e: ChangeEvent<HTMLInputElement>) {
        if (!newGroupReservationData?.payment_methods) return
        const value = e.target.value
        const name = e.target.name
        const oldItem = newGroupReservationData.payment_methods.find((item: CommonTypes.PaymentMethods) => item.name === name)
        if (!oldItem) return
        const index = newGroupReservationData.payment_methods.indexOf(oldItem)
        const filteredList = [...newGroupReservationData.payment_methods.filter((item: CommonTypes.PaymentMethods) => item.name !== name)]
        const newData = {...oldItem, value}
        setNewGroupReservationData({...newGroupReservationData, payment_methods: insert(filteredList, index, newData)})
    }

    function deletePayment(name: string) {
        if (!newGroupReservationData?.payment_methods) return
        const newList = newGroupReservationData.payment_methods.filter((item: CommonTypes.PaymentMethods) => item.name !== name)
        setNewGroupReservationData({...newGroupReservationData, payment_methods: newList})
    } 

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        console.log(newGroup);
        setIsLoading(true)
        if (!newGroupReservationData?.tickets || !newGroupReservationData?.price) return setIsLoading(false)
        if (newGroupReservationData?.payment_methods) {
            const isComplete = newGroupReservationData.payment_methods.every((item: CommonTypes.PaymentMethods) => item.value)
            if (!isComplete) return
        }
        if (!newGroup.length) return
        // En un privado se manda el total del vehículo en cada reserva y el backend lo reparte entre
        // todas: la parte final de cada pasajero es esta (la respuesta de los primeros queda vieja).
        const partes = privado ? repartir(newGroupReservationData.price, newGroup.length) : []
        try {
            for (let i = 0; i < newGroup.length; i++) {
                const passenger = newGroup[i];
                const response = (await SellerService.createReservation({passenger_id: passenger.id , ...newGroupReservationData} as CommonTypes.SubmitReservation))
                const price = privado ? partes[i] : newGroupReservationData.price
                setSummary(prev => ([...prev, {...response.data, reservation: {...response.data.reservation, price}}]))
                setMessage({
                    type: 'success',
                    content: 'Passengers successfully assigned to tour'
                })
                setNewGroupReservations(prev => [...prev, {
                    id: response.data.reservation.id,
                    price,
                    tickets: newGroupReservationData.tickets,
                    tour_id: newGroupReservationData.tour_id,
                    reservation_date: newGroupReservationData.reservation_date,
                } as CommonTypes.Reservation])
            }
            setIsConfirmBoucherModalOpen(true)
        } catch (error) {
            setMessage({
                type: 'error',
                content: 'An error occurred, please try again'
            })
        }
        finally {
            setIsLoading(false)
            setTimeout(() => setMessage(undefined), 5000)
        }
        console.log(newGroupReservationData)
        
    }
    console.log(tour)
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Payment</h1>
            {
                privado
                ? <h3>Tour privado: precio y pagos del vehículo completo, se dividen entre los {newGroup.length} pasajeros*</h3>
                : <h3>Prices per passenger, not general*</h3>
            }
            <GeneralInput
            label={privado ? "Ticket Price* (por pasajero)" : "Ticket Price*"}
            placeholder="$20000"
            value={newGroupReservationData?.tickets || ''}
            name="tickets"
            type="number"
            onChange={onChange}
            image={dollar}
            
            />
            <Select
            style={{margin: '1rem 0'}}
            defaultNull={true}
            label={privado ? "Precio del privado (vehículo completo)" : "Sale Price Options"}
            options={price_options}
            onChange={(e) => setNewGroupReservationData({...newGroupReservationData, price: Number(e.target.value)})}
            />
            {
                privado && parte > 0 &&
                <p style={{margin: '-6px 0 12px', fontSize: '14px'}}>{newGroup.length} pasajeros × ~${parte} cada uno</p>
            }
            {
                sobreCupo &&
                <p style={{margin: '-6px 0 12px', fontSize: '14px', color: '#b45309'}}>Ojo: el privado es para {tour?.capacidad_ofrecida} pasajeros y el grupo tiene {newGroup.length}. Si van en más de un vehículo, el precio tiene que ser el de todos.</p>
            }
            <h3 className="payment-title">{privado ? 'Pagos del grupo (total)' : 'Payment methods'}</h3>
                {
                    newGroupReservationData?.payment_methods?.map((method: CommonTypes.PaymentMethods, idx: number) => {
                        return (
                            <PaymentMethod key={idx}>
                                <button
                                onClick={() => deletePayment(method.name)}
                                >
                                    <FaTrash/>
                                </button>
                                <GeneralInput
                                value={method.value || ''}
                                name={method.name}
                                type="number"
                                placeholder="Amount"
                                label={method.name}
                                image={dollar}
                                onChange={onChangePayment}
                                />
                            </PaymentMethod>
                        )
                    })
                }
                <Dropdown
                style={{marginTop: '20px'}}
                options={['Efectivo', 'Tarjeta Santander', 'Tarjeta BCI', 'Trasnferencia Santander', 'Transferencia BCI', 'Wise David', 'Link de Pago', 'Deuda'].filter(str => !newGroupReservationData?.payment_methods?.map((item: CommonTypes.PaymentMethods) => item.name).includes(str))}
                title="Payment methods"
                onSelect={onSelectPayment}
                />
            <div className="actions">
                <button type="submit">Continue</button>
            </div>
            <div className="close" 
            onClick={() => setIsTicketPaymentGroupModalOpen(false)}
            title="close">
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}

const PaymentMethod = styled.div`
margin-bottom: 10px;
position: relative;
button {
    position: absolute;
    right: 0;
    top: 0;
    height: 25px;
    width: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background-color: rgba(0,0,0,0);
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid ${props => props.theme.dark};
}
h4 {
    font-weight: 400;
    margin-bottom: 5px;
}
label {
    text-transform: capitalize;
    }
`